import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import UserLayout from "./../../layouts/UserLayout/UserLayout";
import DashboardUser from "../../pages/User/DashboardUser/DashboardUser";
import DashboardUserContext from "../../context/UserContext/DashboardUserContext/DashboardUserContext";
import ProfileUser from "../../pages/User/ProfileUser/ProfileUser";
import ProfileUserContext from "../../context/UserContext/ProfileUserContext/ProfileUserContext";
import NotificationsUser from "../../pages/User/NotificationsUser/NotificationsUser";
import NotificationUserContext from "../../context/UserContext/NotificationUserContext/NotificationUserContext";
import TransactionsUser from "../../pages/User/TransactionsUser/TransactionsUser";
import TransactionUserContext from "../../context/UserContext/TransactionUserContext/TransactionUserContext";
import TicketsUser from "../../pages/User/TicketsUser/TicketsUser";
import TicketUserContext from "../../context/UserContext/TicketUserContext/TicketUserContext";
import OrdersUser from "../../pages/User/OrdersUser/OrdersUser";
import OrderUserContext from "../../context/UserContext/OrderUserContext/OrderUserContext";
import InvoicesUser from "../../pages/User/InvoicesUser/InvoicesUser";
import InvoiceUserContext from "../../context/UserContext/InvoiceUserContext/InvoiceUserContext";
import RenewalsUser from "../../pages/User/RenewalsUser/RenewalsUser";
import RenewalUserContext from "../../context/UserContext/RenewalUserContext/RenewalUserContext";
import CategoriesPublic from "../../pages/Public/CategoriesPublic/CategoriesPublic";
import CategoryPublicContext from "../../context/PublicContext/CategoryPublicContext/CategoryPublicContext";
import ProductPublic from "../../pages/Public/ProductPublic/ProductPublic";
import ProductsPublic from "../../pages/Public/ProductsPublic/ProductsPublic";
import ProductPublicContext from "../../context/PublicContext/ProductPublicContext/ProductPublicContext";
import PaymentsUser from "../../pages/User/PaymentsUser/PaymentsUser";
import PaymentUserContext from "../../context/UserContext/PaymentUserContext/PaymentUserContext";
import FAQPublic from "../../pages/Public/FAQPublic/FAQPublic";
import TermsPublic from "../../pages/Public/TermsPublic/TermsPublic";
import AboutUsPublic from "../../pages/Public/AboutUsPublic/AboutUsPublic";
import NotFoundPage from "../../pages/Page/NotFoundPage/NotFoundPage";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems } from "../../utils/enum";

const StaffContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[1])
    return <Navigate to="/" replace />;

  return (
    <UserLayout>
      <Routes>
        {/* Dashboard */}
        <Route
          index
          element={
            <DashboardUserContext>
              <DashboardUser />
            </DashboardUserContext>
          }
        />

        {/* Notifications */}
        <Route
          path="/notifications"
          element={
            <NotificationUserContext>
              <NotificationsUser />
            </NotificationUserContext>
          }
        />

        {/* Transactions */}
        <Route
          key="/transactions"
          path="/transactions"
          element={
            <TransactionUserContext>
              <TransactionsUser />
            </TransactionUserContext>
          }
        />

        {/* Profile */}
        {["/profile", "/profile/changed-password", "/profile/settings"].map(
          (key) => (
            <Route
              key={key}
              path={key}
              element={
                <ProfileUserContext>
                  <ProfileUser />
                </ProfileUserContext>
              }
            />
          )
        )}

        {/* Tickets */}
        {["/tickets", "/tickets/:id"].map((key) => (
          <Route
            key={key}
            path={key}
            element={
              <TicketUserContext>
                <TicketsUser />
              </TicketUserContext>
            }
          />
        ))}

        {/* Orders */}
        {["/orders", "/orders/:invoice/invoice"].map((path) => (
          <Route
            path={path}
            element={
              <OrderUserContext>
                <OrdersUser />
              </OrderUserContext>
            }
          />
        ))}

        {/* Invoices */}
        <Route
          path="/invoices"
          element={
            <InvoiceUserContext>
              <InvoicesUser />
            </InvoiceUserContext>
          }
        />

        {/* Renewals */}
        {[
          "/renewals",
          "/renewals/:order/order",
          "/renewals/:invoice/invoice",
        ].map((path) => (
          <Route
            path={path}
            element={
              <RenewalUserContext>
                <RenewalsUser />
              </RenewalUserContext>
            }
          />
        ))}

        {/* Category */}
        {["/category", "/category/:category/category"].map((path) => (
          <Route
            path={path}
            element={
              <CategoryPublicContext>
                <CategoriesPublic />
              </CategoryPublicContext>
            }
          />
        ))}

        {/* Products */}
        {["/product", "/product/:category/category"].map((path) => (
          <Route
            path={path}
            element={
              <ProductPublicContext>
                <ProductsPublic />
              </ProductPublicContext>
            }
          />
        ))}

        {/* Product */}
        <Route
          path="/product/:product/product"
          element={
            <ProductPublicContext>
              <ProductPublic />
            </ProductPublicContext>
          }
        />

        {/* Payments */}
        {["/payments", "/payments/:invoice/invoice"].map((path) => (
          <Route
            path={path}
            element={
              <PaymentUserContext>
                <PaymentsUser />
              </PaymentUserContext>
            }
          />
        ))}

        {/* FAQ */}
        <Route path="/faq" element={<FAQPublic />} />

        {/* Terms */}
        <Route path="/terms" element={<TermsPublic />} />

        {/* About Us */}
        <Route path="/about-us" element={<AboutUsPublic />} />

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </UserLayout>
  );
};

export default StaffContainer;
